module.exports = __webpack_public_path__ + "img/53.6.CODm.b1dad4d8.png";